import React, { useState, useEffect } from 'react'
// import heroImage from 'images/iStock-regatta-crew-p-2000.jpeg'
//import heroImage from 'images/regatta-2020-08-08.jpeg'
import heroImage from 'images/homepage/Hero Image@2x.png'

// import {setLKBody} from 'lkcss'
import { mapClasses } from 'util/cssModule'
import { track_ux_event } from '../../../services/clarivor-tracking'
import { globalAuthManager } from '../../../services/GlobalServices'

const HeroSection = () => {
    const [scrollY, setScrollY] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Handle scroll effect
        const handleScroll = () => {
            if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
                setScrollY(window.scrollY * 0.05);
            }
        };

        // Handle visibility for fade-in
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        const imageElement = document.querySelector('.hero-img');
        if (imageElement) {
            observer.observe(imageElement);
        }

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (imageElement) {
                observer.unobserve(imageElement);
            }
        };
    }, []);

    return (
        <React.Fragment>
            <div className={'px-4'}>
                <section className={mapClasses(null, 'pt-4 pt-sm-8 pb-9 pt-md-11 pb-md-13 bg-white')} style={{ minHeight: '40vh' }}>
                    <div className={mapClasses(null, 'container')}> 
                        <div className={mapClasses(null, 'row align-items-center flex-column flex-md-row')}> 
                            <div className={mapClasses(null, 'col-12 col-md-6 d-flex flex-column justify-content-center mb-6 mb-md-0')}> 
                                    <h1 className={mapClasses(null, 'font-weight-bold mb-4')} style={{ color: '#26203C' }}>
                                        Deliver institutional-grade option overlays across client accounts
                                    </h1>
                                    <p className={mapClasses(null, 'lead lead-md mb-5')} style={{ color: '#26203C' }}>
                                        Construct, execute and reconcile custom option-based solutions with reduced operational overhead
                                    </p>
                                    <a data-toggle="modal" href="#requestDemoModal" style={{ textDecoration: 'none' }}
                                       onClick={() => {
                                           track_ux_event(localStorage.uuid, 'Request Demo', { source: 'Homepage Hero' }, globalAuthManager)
                                       }}>
                                        <button className="btn btn-success lift mt-2 d-flex">
                                            <span className={'my-auto'}>Request Demo</span>
                                        </button>
                                    </a>
                            </div>
                            <div className={mapClasses(null, 'col-12 col-md-6 d-flex justify-content-center align-items-center')}> 
                                <img 
                                    className="hero-img px-0 px-sm-5 px-md-0"
                                    src={heroImage} 
                                    alt="Platform dashboard illustration" 
                                    style={{ 
                                        maxWidth: '100%', 
                                        height: 'auto', 
                                        borderRadius: '24px',
                                        width: '100%',
                                        opacity: isVisible ? 1 : 0,
                                        transform: `translateY(${isVisible ? scrollY : 12}px)`,
                                        transition: 'opacity 200ms ease-out 60ms, transform 200ms ease-out 60ms',
                                        willChange: 'transform'
                                    }} 
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="position-relative">
                <div className="shape shape-bottom shape-fluid-x svg-shim text-light">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>
        </React.Fragment>
    )
}

export default HeroSection